/**
 * Centralised env access. Throws early if required vars are missing,
 * so we fail loudly rather than `undefined`-propagating.
 */

interface AppEnv {
  apiUrl: string;
  wsUrl: string;
  tgBotUsername: string;
  miniAppUrl: string;
  webUrl: string;
  useMocks: boolean;
  isDev: boolean;
}

function readString(key: keyof ImportMetaEnv, fallback?: string): string {
  const raw = import.meta.env[key];
  if (typeof raw === 'string' && raw.length > 0) return raw;
  if (fallback !== undefined) return fallback;
  throw new Error(`Missing required env var: ${String(key)}`);
}

export const env: AppEnv = {
  apiUrl: readString('VITE_API_URL', 'https://api.olabotardivna.com/api/v1'),
  wsUrl: readString('VITE_WS_URL', 'wss://api.olabotardivna.com/ws/'),
  tgBotUsername: readString('VITE_TG_BOT_USERNAME', 'Ola_Botardivna_bot'),
  miniAppUrl: readString('VITE_MINI_APP_URL', 'https://tg.olabotardivna.com'),
  webUrl: readString('VITE_WEB_URL', 'https://olabotardivna.com'),
  useMocks: import.meta.env.VITE_USE_MOCKS === 'true',
  isDev: import.meta.env.DEV,
};
